import React from 'react';
import { GlobalContext } from '../../GlobalContext';

function WarningAmoutMessage() {
  const global = React.useContext(GlobalContext);
  const { warningLowRawMaterial, setWarningLowRawMaterial, hasRawMaterial, packageTier } = global;

  React.useEffect(() => {
    // Se o plano não possui controle de estoque/insumos, limpa avisos antigos
    if (!hasRawMaterial) {
      localStorage.removeItem('warningAmountMessage');
      setWarningLowRawMaterial([]);
      return;
    }

    const raw = localStorage.getItem('warningAmountMessage');
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          setWarningLowRawMaterial(parsed);
        }
      } catch (err) {
        console.error('Erro ao ler warningAmountMessage:', err);
      }
    }
  }, [setWarningLowRawMaterial, hasRawMaterial, packageTier]);

  const dismissWarning = (idx) => {
    const updated = (warningLowRawMaterial || []).filter((_, i) => i !== idx);
    setWarningLowRawMaterial(updated);
    localStorage.setItem('warningAmountMessage', JSON.stringify(updated));
  };

  // Não renderiza se o projeto for apenas cardápio/sem estoque
  if (!hasRawMaterial) {
    return null;
  }

  if (!warningLowRawMaterial || warningLowRawMaterial.length === 0) {
    return null;
  }

  return (
    <div style={{ margin: '10px 0' }}>
      {warningLowRawMaterial.map((msg, idx) => (
        <div 
          key={idx} 
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            backgroundColor: '#fff3cd',
            color: '#856404',
            border: '1px solid #ffeeba',
            borderRadius: '6px',
            padding: '8px 14px',
            marginBottom: '6px'
          }}
        >
          <span style={{ fontWeight: '600', fontSize: '0.9rem' }}>{msg}</span>
          <button 
            type="button" 
            onClick={() => dismissWarning(idx)}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: '#856404', 
              fontSize: '16px', 
              cursor: 'pointer',
              fontWeight: 'bold',
              marginLeft: '10px'
            }}
            title="Fechar aviso"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}

export default WarningAmoutMessage;
